// Environment configuration with validation

interface EnvConfig {
  apiBaseUrl: string;
  isDevelopment: boolean;
  isProduction: boolean;
  /** Hours after which the email verification link expires (default 24) */
  emailVerificationExpiryHours: number;
}

function getEnvConfig(): EnvConfig {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';
  const raw = import.meta.env.VITE_EMAIL_VERIFICATION_EXPIRY_HOURS;
  const emailVerificationExpiryHours = raw != null && raw !== ''
    ? Math.max(1, parseInt(String(raw), 10) || 24)
    : 24;

  return {
    apiBaseUrl,
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    emailVerificationExpiryHours,
  };
}

export const env = getEnvConfig();

// Validate required environment variables in production
if (env.isProduction) {
  const requiredVars = ['VITE_API_BASE_URL'];
  const missingVars = requiredVars.filter(
    (varName) => !import.meta.env[varName]
  );

  if (missingVars.length > 0) {
    console.warn(
      `Missing required environment variables: ${missingVars.join(', ')}`
    );
  }
}
